angular.module('accessWebClient')
    .controller('CreateFileModalController', ['$scope', '$modalInstance', 'parent', 'OfficeOnlineExtensions', 'SyncAndShareNode', '$translate', '$routeParams', 'flashMessagesService',
        function ($scope, $modalInstance, parent, OfficeOnlineExtensions, SyncAndShareNode, $translate, $routeParams, flashMessagesService) {
            var PLACEHOLDER_TEXT = $translate.instant('Filename'),
                PLACEHOLDER_REQUIRED_TEXT = $translate.instant('Please enter a filename'),
                DEFAULT_EXTENSION = 'docx',
                constructor = parent.constructor,
                actionButton = $modalInstance.options.actionButton,
                overwrite = false;

            $scope.modal = $modalInstance.options;

            $scope.file = {
                name: '',
                extension: ''
            };

            $scope.resetPlaceholderText = function() {
                $scope.placeholderText = PLACEHOLDER_TEXT;
            };

            $scope.resetConflict = function() {
                $scope.modal.actionButton = actionButton;
                overwrite = false;
            };

            $scope.resetPlaceholderText();

            $scope.modal.loading = true;
            OfficeOnlineExtensions.available({}, {action: 'editnew'}, function (extensions) {
                $scope.extensions = extensions;
                $scope.file.extension = DEFAULT_EXTENSION;
                $scope.modal.loading = false;
            });

            $scope.getFilename = function(){
                return [$scope.file.name, $scope.file.extension].join('.');
            };

            $scope.ok = function () {
                if ($scope.file.name.length == 0) {
                    $scope.placeholderText = PLACEHOLDER_REQUIRED_TEXT;
                    return;
                }

                $scope.modal.loading = true;
                constructor.createNode({
                        name: $scope.getFilename(),
                        parent_uuid: ($routeParams.uuid || 0).toString(),
                        is_directory: false,
                        overwrite: overwrite
                    },
                    function (emptyFile) {
                        constructor.getNode({
                            id: $routeParams.id,
                            uuid: emptyFile.uuid
                        }, function (emptyFileWithPermissions) {
                            $modalInstance.close(emptyFileWithPermissions)
                        });
                    }, function (response) {
                        if (response.status == 409) {
                            flashMessagesService.add($translate.instant("'%{node_name}' already exists in this location.", {node_name: $scope.getFilename()}), flashMessagesService.ERROR);
                            $scope.modal.actionButton = $translate.instant('Overwrite');
                            $scope.modal.loading = false;
                            overwrite = true;
                        }
                    });
            };

            $scope.cancel = $scope.close = function () {
                $modalInstance.dismiss();
            };
        }]);
